var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMusicOn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    fill: "none",
    viewBox: "0 0 59 59",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M33.633 38.463a4.624 4.624 0 0 1 4.543-4.704l.716-.012c.255.13.483-.009.733-.13.247-.255.243-.487.239-.72l-.18-10.31c-.007-.369-.01-.6-.264-.731-.118-.114-.488-.224-.739-.22L25.666 19.91a.834.834 0 0 0-.836.866l.213 20.006.002.136c.04 2.301-1.972 4.524-4.526 4.568-2.553.045-4.777-2.103-4.822-4.657s2.106-4.643 4.66-4.687l.6-.01c.386-.008.618-.012.846-.268.133-.118.244-.371.24-.604l-.36-20.623 20.9 1.106.398 22.79c-.074 2.439-2.11 4.41-4.645 4.454-2.553.045-4.659-1.988-4.703-4.523",
    clipRule: "evenodd"
  })));
};
export default SvgMusicOn;